// extracted by mini-css-extract-plugin
export var footer = "_kv-5";
export var fulfillmentInput = "_kv-0";
export var shipDateInput = "_kv-1";
export var shipmentModal = "_kv-2";
export var shipmentModalContent = "_kv-3";
export var tableContainer = "_kv-4";